const ALPHANUMERIC_PASSWORD_LENGTH_MIN_MAX = { min: 4, max: 5 };

export const generateAlphanumericPasswordAccess = (
  length: number = ALPHANUMERIC_PASSWORD_LENGTH_MIN_MAX.min
): string => {
  // Validação do comprimento
  if (
    length < ALPHANUMERIC_PASSWORD_LENGTH_MIN_MAX.min ||
    length > ALPHANUMERIC_PASSWORD_LENGTH_MIN_MAX.max
  ) {
    throw new Error(
      `Password length must be between ${ALPHANUMERIC_PASSWORD_LENGTH_MIN_MAX.min} and ${ALPHANUMERIC_PASSWORD_LENGTH_MIN_MAX.max}.`
    );
  }

  // Conjuntos de caracteres
  const numbers = '0123456789';
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  const allCharacters = numbers + letters;

  // Garante pelo menos 1 número e 1 letra
  let password = [
    letters[Math.floor(Math.random() * letters.length)],
    numbers[Math.floor(Math.random() * numbers.length)],
  ].join('');

  // Completa o restante dos caracteres
  for (let i = password.length; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * allCharacters.length);
    password += allCharacters[randomIndex];
  }

  // Embaralha os caracteres
  return password
    .split('')
    .sort(() => Math.random() - 0.5)
    .join('');
};

export const generateNumericPasswordAccess = (
  length: number = 4
): string => {

  // Conjunto de caracteres (somente dígitos)
  const numbers = '0123456789';

  // Monta a senha
  let password = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * numbers.length);
    password += numbers[randomIndex];
  }

  return password;
};

interface ValidationResult {
  isValid: boolean;
  errors?: string[];
}

export const validateUserResponsiblePassword = (
  password: string
): ValidationResult => {
  const errors: string[] = [];

  if (password.length < 4) errors.push('Mínimo 4 caracteres');
  if (password.length > 5) errors.push('Máximo 5 caracteres');
  if (/[^A-Za-z0-9]/.test(password))
    errors.push('Apenas letras e números são permitidos');

  return {
    isValid: errors.length === 0,
    errors: errors.length > 0 ? errors : undefined,
  };
};
export const validateOperatorPassword = (
  password: string
): ValidationResult => {
  const errors: string[] = [];

  if (password.length !== 4) errors.push('Senha deve conter 4 caracteres');
  if (/[^0-9]/.test(password)) errors.push('Apenas números são permitidos');

  return {
    isValid: errors.length === 0,
    errors: errors.length > 0 ? errors : undefined,
  };
};
